import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=34ca45ec&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=34ca45ec&prod&lang=less"
import style1 from "./shopList.vue?vue&type=style&index=1&id=34ca45ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca45ec",
  null
  
)

export default component.exports